import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Region } from 'src/app/shared/models/region';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class RegionService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllRegion(): Observable<Region[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.regionUrl}/all`,
			'getAllRegion'
		);
	}

	importRegion(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'region.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.regionUrl}/import`,
			`importRegion`,
			formData
		);
	}

	getRegionById(id: number): Observable<Region> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.regionUrl}/get/${id}`,
			'getRegionById'
		);
	}

	getRegionsByUser(userId: number): Observable<Region[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.regionUrl}/getByUserId/${userId}`,
			'getRegionsByUser'
		);
	}

	updateRegion(region: Region): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.regionUrl}/update/${region.id}`,
			'updateRegion',
			region
		);
	}

	addRegion(region: Region): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.regionUrl}/add`,
			'addRegion',
			region
		);
	}

	deleteRegion(regionId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.regionUrl}/delete/${regionId}`,
			`deleteRegion`
		);
	}
}
